import { Grid, TextField, Tooltip, Box } from '@mui/material'
import { useCallback, useEffect } from 'react'
import { metodoPrograma } from '../../../../components/api'
import PrimeTable from '../../../../components/PrimeTable'
import NumberSpinner from '../../../financeiro/pontoDeVenda/qunatidadeProdutoTable'

export const ProdutoAgendamento = ({
  idAgendamento,
  disabilitado = false,
  listaProduto,
  setListaProduto,
}) => {
  const getLista = useCallback(() => {
    metodoPrograma('listaProduto', {
      idAgendamento,
    }).then((response) => {
      if (response.status) {
        setListaProduto(response.lista)
      }
    })
  }, [idAgendamento, setListaProduto])

  useEffect(() => {
    getLista()
  }, [getLista])

  const trataObservacaoLinha = (linha) => (event) => {
    const novaObs = event.target.value

    setListaProduto((prev) =>
      prev.map((item) => {
        if (item[0] === linha[0]) {
          const novaLinha = [...item]
          novaLinha[7] = novaObs
          return novaLinha
        }
        return item
      }),
    )
  }

  const trataQuantidadeLinha = (linha) => (quantidade) => {
    setListaProduto((prev) =>
      prev.map((item) => {
        if (item[0] === linha[0]) {
          const novaLinha = [...item]
          novaLinha[6] = quantidade
          return novaLinha
        }
        return item
      }),
    )
  }

  return (
    <Grid item xs={12}>
      <PrimeTable
        dadosTable={listaProduto}
        disablePagination
        head={['Medicamento', 'Quantidade', 'Observações', 'Aceitou']}
        colStyle={[{ width: '65%' }]}
        rowHighlight={(row) => (row[8] == null ? false : row[6] > row[8])}
        rowClassName={(rowData) => {
          return rowData.original?.destacar ? 'row-highlight' : ''
        }}
        line={(item) => [item?.[1], 0]}
        columnOptions={[
          {
            alias: 0,
            customJsx: ({ linhaOriginal }) => (
              <Grid container>
                <Grid item xs={12}>
                  <Tooltip title={linhaOriginal?.[1]}>
                    <span
                      style={{
                        fontSize: '2.0vh',
                        fontWeight: 370,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        display: 'block',
                      }}
                    >
                      {linhaOriginal?.[1]}
                    </span>
                  </Tooltip>
                </Grid>
              </Grid>
            ),
          },
          {
            alias: 1,
            customJsx: ({ linhaOriginal }) => (
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                }}
              >
                <NumberSpinner
                  size="small"
                  disabled={disabilitado}
                  onChange={trataQuantidadeLinha(linhaOriginal)}
                  value={linhaOriginal?.[6]}
                  min={0}
                />
              </Box>
            ),
          },
          {
            alias: 2,
            customJsx: ({ linhaOriginal }) => (
              <>
                {linhaOriginal?.[6] > 0 && (
                  <TextField
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    size="small"
                    disabled={disabilitado}
                    value={linhaOriginal?.[7] || ''}
                    onChange={trataObservacaoLinha(linhaOriginal)}
                    placeholder="..."
                  />
                )}
              </>
            ),
          },
          {
            alias: 3,
            customJsx: ({ linhaOriginal }) => <>{linhaOriginal[8]}</>,
          },
        ]}
      />
    </Grid>
  )
}
